import React from "react";
import { Redirect, Link, withRouter } from "react-router-dom";
import logo from "./../assets/images/muvi-studio-logo.png";
import Vector from "../assets/Logo.js";
import config from "react-global-configuration";
import Common from "./../Common";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import action from "../Actions";
import Message from "./UI/Message.js";
class Login extends Common {
  constructor(props) {
    super(props);
    document.title = config.get("project_title") + " | Login";
    this.state = {
      email: "",
      password: "",
      redirect: false,
      message: "",
      board: {
        position: "bottom-end",
      },
      isChecked: false,
      showPassword: false,

      apiUrl: this.decryptconfigdata("apiUrl"),
      fields: {},
    };
    this.login = this.login.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onChangeCheckbox = (event) => {
    this.setState({
      isChecked: event.target.checked,
    });
  };

  clearLocalStorage() {
    localStorage.clear();
  }

  getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(window.location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  }
  async componentDidMount() {
    const { state } = this.props.location;
    if (state) {
      this.setState((ps) => {
        return {
          ...ps,
          board: {
            ...ps.board,
            ...state,
          },
        };
      });
    }
    let isLoggedin = await this.checklogion();
    if (isLoggedin == true) {
      this.props.history.push("/board/list");
    }
  }

  login() {
    if (this.state.email && this.state.password) {
      document.getElementById("login_btn").innerHTML = "Sending....";
      document.getElementById("login_btn").disabled = true;
      fetch(this.state.apiUrl + "userLogin", {
        method: "POST",
        dataType: "json",
        body: JSON.stringify(this.state),
      })
        .then((response) => response.json())
        .then((result) => {
          var encdata = result.encdata;
          result = this.decrypt(encdata, 0);
          console.log(result, 54243243234234);
          if (result.data && result.data.user.length === 0) {
            document.getElementById("login_btn").innerHTML = "Login";
            this.setState((state) => {
              return {
                ...state,
                email: "",
                password: "",
                board: {
                  ...state.board,
                  board: true,
                  title: "Error",
                  bg: "danger",
                  message:
                    "Account does not exist. Please check your details and try again",
                },
              };
            });
            document.getElementById("login_btn").disabled = false;
            setTimeout(() => {
              this.props.history.push("/login");
            }, 2000);
            return;
          }
          if (result.code == 200) {
            const { user } = result.data;
            const results_Details = {
              ...result,
              app_token: result.data.app_token,
              is_admin: result.data.user_type == "ROLE_ADMIN" ? 1 : 0,
              user_uuid: result.data.user_uuid,
            };
            var check_is_admin = result.data.user_type == "ROLE_ADMIN" ? 1 : 0;
            const user_details = JSON.stringify(result?.data?.user);

            const userDetailsParse = JSON.parse(user_details);
            this.setToStorage("is_admin", check_is_admin);
            this.setToStorage("user_uuid", userDetailsParse[0].user_uuid);
            this.setToStorage("app_token", userDetailsParse[0].app_token);
            this.setToStorage("userLogin", "yes");
            this.setToStorage("token", result.token);
            // Cookies.set("token", result.token, {
            //   path: "/",
            //   domain: process.env.REACT_APP_COOKIE_DOMAIN,
            // });
            this.setToStorage("user_details", user_details);
            sessionStorage.setItem("userLogin", "yes");
            this.setState({ redirect: true });
            if (
              user.length > 0 &&
              user?.[0].hasOwnProperty("default_board") &&
              user?.[0].default_board
            ) {
              window.location = `tattle/${user?.[0]?.default_board}/list`;
            } else {
              window.location = "/board/list";
            }
          } else {
            this.setState({ message: result.msg });
            document.getElementById("login_btn").innerHTML = "Login";
            document.getElementById("login_btn").disabled = false;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      this.setState({ message: "Please enter valid Username and Password" });
    }
  }
  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  handlePassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }
  render() {
    if (this.state.redirect) {
      return <Redirect to={"/board/list"} />;
    }
    if (localStorage.getItem("userLogin")) {
      return <Redirect to={"/board/list"} />;
    }
    return (
      <div class="cms-child mainContent fullScreen">
        <Message board={this.state.board} />
        <div class="mainContent-panel-wrap">
          <div class="content-wrapper">
            <div class="wrapper">
              <div class="page-content">
                <div class="row justify-content-center mt-5 pt-4">
                  <div class="col col-sm-7 col-md-7 col-lg-5 col-xl-4 col-xxl-4 px-4">
                    <div class="cardRow">
                      <div class="card p-md-5 p-2 bg-transparent shadow-none">
                        <div class="d-flex">
                          <div class="brand">
                            <Link to="/" className="site_logo">
                              <Vector />
                            </Link>
                          </div>
                        </div>
                        <h6 class="title txt-dark pt-3 pb-4 mb-3">Login</h6>
                        <form
                          class="needs-validation"
                          novalidate
                          action="javascript:void(0);"
                          onSubmit={() => this.login()}
                        >
                          <div class="mb-3">
                            <div class="searchBox border">
                              <div class="input-group input-group-lg">
                                <span class="input-group-text">
                                  <svg
                                    width="21"
                                    height="20"
                                    viewBox="0 0 21 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M3.83341 3.33325H17.1667C18.0834 3.33325 18.8334 4.08325 18.8334 4.99992V14.9999C18.8334 15.9166 18.0834 16.6666 17.1667 16.6666H3.83341C2.91675 16.6666 2.16675 15.9166 2.16675 14.9999V4.99992C2.16675 4.08325 2.91675 3.33325 3.83341 3.33325Z"
                                      stroke="#5C5F62"
                                      stroke-width="1.67"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M18.8334 5L10.5001 10.8333L2.16675 5"
                                      stroke="#5C5F62"
                                      stroke-width="1.67"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </span>
                                <input
                                  type="email"
                                  name="email"
                                  class="form-control ps-0"
                                  value={this.state.email}
                                  aria-label="Sizing example input"
                                  aria-describedby="inputGroup-sizing-sm"
                                  placeholder="Email address"
                                  required
                                  onChange={this.onChange}
                                  data-validate="Password is required"
                                />
                                {/* </div> */}
                              </div>
                            </div>
                          </div>
                          <div class="mb-3">
                            <div class="searchBox border">
                              <div class="input-group input-group-lg has-validation">
                                <span class="input-group-text">
                                  <svg
                                    width="19"
                                    height="18"
                                    viewBox="0 0 19 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M14.75 8.25H4.25C3.42157 8.25 2.75 8.92157 2.75 9.75V15C2.75 15.8284 3.42157 16.5 4.25 16.5H14.75C15.5784 16.5 16.25 15.8284 16.25 15V9.75C16.25 8.92157 15.5784 8.25 14.75 8.25Z"
                                      stroke="#5C5F62"
                                      stroke-width="1.67"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M5.75 8.25V5.25C5.75 4.25544 6.14509 3.30161 6.84835 2.59835C7.55161 1.89509 8.50544 1.5 9.5 1.5C10.4946 1.5 11.4484 1.89509 12.1517 2.59835C12.8549 3.30161 13.25 4.25544 13.25 5.25V8.25"
                                      stroke="#5C5F62"
                                      stroke-width="1.67"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </span>
                                <input
                                  type={
                                    this.state.showPassword
                                      ? "text"
                                      : "password"
                                  }
                                  name="password"
                                  class="form-control ps-0"
                                  value={this.state.password}
                                  aria-label="Sizing example input"
                                  aria-describedby="inputGroup-sizing-sm"
                                  placeholder="Password"
                                  required
                                  onChange={this.onChange}
                                />
                                <span
                                  onClick={() => this.handlePassword()}
                                  class="input-group-text cursor toggle-password"
                                >
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M15.7316 6.50933C15.9658 6.65568 16.037 6.96416 15.8906 7.19833C15.4176 7.95519 14.8544 8.64267 14.2136 9.23985L15.519 10.5453C15.7143 10.7406 15.7143 11.0572 15.519 11.2524C15.3238 11.4477 15.0072 11.4477 14.8119 11.2524L13.4443 9.88478C12.5839 10.5316 11.6131 11.0291 10.5553 11.3384L11.0429 13.1582C11.1144 13.425 10.9561 13.6991 10.6894 13.7706C10.4226 13.842 10.1485 13.6838 10.077 13.417L9.58071 11.5648C9.07 11.6536 8.54231 11.7 7.99994 11.7C7.45756 11.7 6.92986 11.6536 6.41914 11.5648L5.92291 13.417C5.85144 13.6837 5.57728 13.842 5.31055 13.7706C5.04381 13.6991 4.88551 13.425 4.95697 13.1582L5.44452 11.3384C4.38676 11.0291 3.41594 10.5315 2.55557 9.88476L1.18793 11.2524C0.992668 11.4477 0.676086 11.4477 0.480824 11.2524C0.285562 11.0571 0.285561 10.7406 0.480824 10.5453L1.78629 9.23983C1.14551 8.64265 0.582309 7.95518 0.109271 7.19833C-0.0370842 6.96416 0.0341017 6.65568 0.26827 6.50933C0.502438 6.36297 0.810913 6.43416 0.957269 6.66833C1.47072 7.48984 2.09782 8.21647 2.81919 8.81855C2.83023 8.82697 2.841 8.8359 2.85146 8.84535C4.25978 10.009 6.0235 10.7 7.99994 10.7C11.0078 10.7 13.523 9.09969 15.0426 6.66832C15.189 6.43416 15.4974 6.36297 15.7316 6.50933Z"
                                      fill="black"
                                    />
                                  </svg>
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="row mb-4 pb-2">
                            <div class="col col-sm col-md col-lg">
                              <div class="form-check">
                                <label
                                  class="form-check-label"
                                  style={{ paddingTop: "3px" }}
                                >
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    onChange={(e) => {
                                      this.setState({
                                        remember: e.target.checked,
                                      });
                                    }}
                                    checked={this.state.remember}
                                    name="remember"
                                  />{" "}
                                  Remember me
                                </label>
                              </div>
                            </div>
                            <div class="col-auto col-sm-auto col-md-auto col-lg-auto">
                              <div class="muBtn _link sm px-0 p-md-0">
                                <a
                                  class="muBtn _link sm px-0 p-md-0"
                                  href={process.env.REACT_APP_FORGOT_PASSWORD}
                                  // onClick={this.clearLocalStorage()}
                                >
                                  Forgot Password?
                                </a>
                              </div>
                            </div>
                          </div>
                          <span className="error"> {this.state.message}</span>
                          <div>
                            <button
                              type="submit"
                              id="login_btn"
                              class="muBtn _blue lg w-100 mb-3"
                            >
                              Login
                            </button>
                          </div>
                          <a
                            href="https://help.muvi.com/help/how-to-use-tattle-as-a-user"
                            className="help_center_icon"
                            target="_blank"
                          >
                            Need Help?
                          </a>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <footer class="page-copyright text-center">
                Muvi LLC, All Rights Reserved
              </footer>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    loginData: (input) => {
      dispatch(action.loginDetails(input));
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
